export const memberColumns: string[] = [
  'ownerName',
  'membershipLength',
  'startMembershipStatus',
  'endMembershipStatus',
  'membershipTypeName',
  'membershipCategoryName',
  'frequency',
  'onHoldBegins',
  'onHoldUntil',
  'validFrom',
  'validTo',
  'priceAmount',
  'discountAmount',
  'priceCurrency',
  'lostMember',
  'revenue',
  'convertedToMembershipTypeName',
  'converted',
  'priceChange',
  'discountChange',
  'trainerName',
  'newMembership',
  'onHoldLength',
];
